// removed by extract-text-webpack-plugin
module.exports = {"block":"content__block-1kcGS"};


//////////////////
// WEBPACK FOOTER
// ./components/account/content/content.css
// module id = 746
// module chunks = 0